module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"widgets.googleAnalytics.widget":[{"value":"mcGoogleAnalytics","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102004},"path":"@root","_fox_":1}],"widgets.apiAddReferer.widget":[{"value":"Api","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102006},"path":"@root","_fox_":1}],"widgets.apiAddReferer.method":[{"value":"site.addReferer","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102007},"path":"@root","_fox_":1}],"widgets.apiAddReferer.domain":[{"value":"https:\u002F\u002Fmodelcentro.com","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102008},"path":"@root","_fox_":1}]},"@root #router":{"hooks.onStopExecute":[{"value":function() {
if (!fox.isEmpty(document.referrer)) {
this.rwom1('@parent #apiAddReferer').send({'referer': document.referrer});
}
var counterCalls = 0;
var currentPage = this._passedRoute.path;
var self = this;
var callback = function() {
counterCalls++;
if (!_gaScriptLoaded && counterCalls < 5) {
setTimeout(arguments.callee, 2000);
return;
}
self.rwom1('@root #googleAnalytics').trackPageview(currentPage, false);
}();
},"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102027},"path":"@root #router","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./options/ga.js
// module id = 81
// module chunks = 0